module.exports = "<div id=RelationNewPage> <cx-rel-wizard success=\"vm.success(relation, isNew)\"></cx-rel-wizard> </div> ";